import { absolutePublicAsset } from '@/config/envLinks';

/**
 * Backend vraća putanje slika kao `/product-images/abc.png` — relativne na svoj origin.
 * U produkciji su frontend i API na istom domenu, pa to radi bez ičega.
 * Kad je API na drugom origin-u (lokalni razvoj: frontend :9080, backend :8080),
 * putanju treba prefiksovati origin-om backenda, inače se slika traži na frontendu.
 */

const API_BASE = process.env.REACT_APP_API_BASE;

/** Origin backenda, izveden iz `REACT_APP_API_BASE` (npr. `http://localhost:8080/api` → `http://localhost:8080`). */
const apiOrigin = () => {
  if (!API_BASE) return '';
  return API_BASE.replace(/\/api\/?$/, '').replace(/\/$/, '');
};

const isAbsolute = (value) => /^https?:\/\//i.test(value);

/** URL slike upotrebljiv u `<img src>`. */
export const mediaUrl = (path) => {
  if (!path || isAbsolute(path)) return path;
  const origin = apiOrigin();
  if (!origin) return path;
  return `${origin}${path.startsWith('/') ? '' : '/'}${path}`;
};

/** Apsolutni URL za `og:image` — deljenje na društvenim mrežama ne prihvata relativne putanje. */
export const absoluteMediaUrl = (path) => {
  const url = mediaUrl(path);
  if (!url || isAbsolute(url)) return url;
  return absolutePublicAsset(url);
};

export default { mediaUrl, absoluteMediaUrl };
